import React, { useEffect, useRef } from "react";
import { setUser } from "../../redux/slice/auth";
import { useHistory } from "react-router-dom";
import { getMe } from "../../redux/slice/root";
import {
  axiosInstance,
  axiosInstanceV1_1,
} from "../../@core/auth/jwt/jwtService";

export default function AuthProvider({
  userManager: manager,
  store,
  children,
}) {
  const userManager = useRef();
  const history = useHistory();

  useEffect(() => {
    userManager.current = manager;

    const onUserLoaded = (user) => {
      store.dispatch(setUser(user));
      localStorage.setItem("idToken", user.id_token);
      const header = `Bearer ${user.access_token}`;
      axiosInstance.defaults.headers.common["Authorization"] = header;
      axiosInstanceV1_1.defaults.headers.common["Authorization"] = header;
      const profile = localStorage.getItem("profile");
      localStorage.setItem("userAccess", user.access_token);
      console.log("onUserLoaded");

      if (profile === null) {
        store
          .dispatch(getMe())
          .then(() => {
            history.push(`/dashboard`);
            location.reload();
          })
          .catch((rejectedValueOrSerializedError) => {
            console.log(
              "rejectedValueOrSerializedError : ",
              rejectedValueOrSerializedError
            );
          });
      }
    };

    const onUserUnloaded = () => {
      console.log(`user unloaded`);
      localStorage.removeItem("userAccess");
    };

    const onAccessTokenExpiring = () => {
      console.log(`user token expiring`);
    };

    const onAccessTokenExpired = () => {
      console.log(`user token expired`);
      localStorage.removeItem("userAccess");
    };

    const onUserSignedOut = () => {
      console.log(`user signed out!`);
    };

    // events for user
    userManager.current.events.addUserLoaded(onUserLoaded);
    userManager.current.events.addUserUnloaded(onUserUnloaded);
    userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
    userManager.current.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.current.events.addUserSignedOut(onUserSignedOut);

    // Specify how to clean up after this effect:
    return function cleanup() {
      userManager.current.events.removeUserLoaded(onUserLoaded);
      userManager.current.events.removeUserUnloaded(onUserUnloaded);
      userManager.current.events.removeAccessTokenExpiring(
        onAccessTokenExpiring
      );
      userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
      userManager.current.events.removeUserSignedOut(onUserSignedOut);
    };
  }, [manager, store]);

  return React.Children.only(children);
}
